import { render, staticRenderFns } from "./viewLogistics.vue?vue&type=template&id=693a1112&scoped=true"
import script from "./viewLogistics.vue?vue&type=script&lang=js"
export * from "./viewLogistics.vue?vue&type=script&lang=js"
import style0 from "./viewLogistics.vue?vue&type=style&index=0&id=693a1112&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693a1112",
  null
  
)

export default component.exports